<template>
  <div id="build-nav">
    <v-toolbar flat fixed>
      <v-btn icon @click="drawer = !drawer" class="hidden-md-and-up">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title>
        <router-link :to="{ name: 'Home' }">
          <img @click="$emit('startOver')" class="builder-logo" src="../../static/images/Dealer-Draft_logo.png">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="build-controls hidden-sm-and-down">
        
        <template v-if="isBuilding">
          <v-btn @click="$emit('startOver')" flat>Start Over</v-btn>
          <v-btn v-if="flowTypes.indexOf(currentFlow) !== 2 && selectedBrand.toLowerCase() !== 'mazda'" :disabled="!canNext" @click="$emit('next')" flat>Next<v-icon right small>arrow_forward</v-icon></v-btn>
          <v-btn :disabled="!canPreview" @click="goToPreview" flat outline class="preview">Preview</v-btn>
        </template>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down extra-padding">
        <router-link :to="{ name: 'Home' }">
          <v-btn @click="$emit('startOver')" flat>Home</v-btn>
        </router-link>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list>
        <v-list-tile to="/builder">
          <v-list-tile-title>Home Build</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/srp-builder">
          <v-list-tile-title>SRP Build</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'SRPBuilderNavbar',
  props: [
    'isBuilding',
    'currentFlow',
    'flowTypes',
    'selectedBrand'
  ],
  data() {
    return {
      canNext: false,
      canPreview: false,
      drawer: false,
    };
  },
  mounted() {
    this.evalNext();
    this.evalPreview();
  },
  computed: {
    ...mapGetters(
      ['imagePreview', 'chosenArray']
    ),
  },
  methods: {
    goToPreview() {
      this.$router.push({ name: 'SRPPreview' })
    },
    evalNext() {
      if (this.flowTypes.indexOf(this.currentFlow) === this.$store.state.chosenComponents.length - 1) {
        this.canNext = true;
      } else {
        this.canNext = false;
      }
    },
    evalPreview() {
      if ((this.flowTypes.indexOf(this.currentFlow) === 2 && this.$store.state.chosenComponents.length === 3) || (this.selectedBrand.toLowerCase() === "mazda" && this.$store.state.chosenComponents.length === 1)) {
        this.canPreview = true;
      } else {
        this.canPreview = false;
      }
    },
  },
  watch: {
    chosenArray: function() {
      this.evalNext();
      this.evalPreview();
    },
    currentFlow: function() {
      this.evalNext();
    }
  }
}
</script>

<style scoped>
  #build-nav {
    height: 64px;
  }
  .builder-logo {
    max-height: 40px;
  }
  .v-toolbar--fixed {
    z-index: 10;
  }
  .build-controls {
    justify-content: space-between;
    min-width: 420px;
  }
  .extra-padding {
    padding-left: 70px;
  }
  #build-nav .preview {
    color: #006aff;
    font-weight: 600;
    height: auto;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .mobile-nav {
    width: 250px;
  }
  @media (max-width: 959px) {
    .v-navigation-drawer--temporary, 
    .v-navigation-drawer--is-mobile {
      z-index: 99999999;
    }
  }
</style>